import type { IRegistrationFlow } from "@/types/global"
import { ref } from "vue"

const geoblocked = ref(false)
const systemSettings = ref()
const registrationFlow = ref<IRegistrationFlow | null>(null)
const isDrawerOpen = ref(true)
const appDivisions = ref([])
const appDivision = ref()
const btcRate = ref(0)
const files = ref([])

export function useConfig() {
  function setSystemSettings(_systemSettings) {
    systemSettings.value = _systemSettings

    appDivisions.value = ((_systemSettings.divisions as any[]) ?? [])
      .filter(division => division.active)
      .map(division => division.name)
  }

  function setRegistrationFlow(_registrationFlow: IRegistrationFlow) {
    registrationFlow.value = _registrationFlow
  }

  function setBtcRate(rate) {
    btcRate.value = rate
  }

  function setFiles(_files) {
    files.value = _files
  }

  return {
    appDivision,
    appDivisions,
    isDrawerOpen,
    geoblocked,
    systemSettings,
    setSystemSettings,
    setBtcRate,
    setFiles,
    files,
    btcRate,
    registrationFlow,
    setRegistrationFlow,
  }
}
